import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { config } from "../utils/constants";
import { setEmail } from "../store/slices/auth.ts"; 
import { setOrderData } from "../store/slices/cartSlice.ts"; 


import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";


export default function CheckoutForm({
  charge_amount,
  shipping_amount,
  email,
  rates_id,
  carrier,
  service_level,
  applied_promotion_code,
}) {

  var REACT_APP_BASE_URL = config.url.REACT_APP_BASE_URL;
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  let return_url = `${REACT_APP_BASE_URL}/payment-success/`;

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }
    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });
  }, [stripe, dispatch, email, charge_amount]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);
    dispatch(
        setEmail({
          email: `${email}`,
        })
      );  
      dispatch(
        setOrderData({
          rates_id: rates_id,
          total_price: parseFloat(charge_amount),
          shipping_price: parseFloat(shipping_amount),
          taxes: 0,
          carrier: carrier,
          service_level: service_level,
          applied_promotion_code: applied_promotion_code,
        })
      );
          
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: return_url,
      },

    });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occurred.");
    }

    setIsLoading(false);
  };

  return (


                        <div className="card-body mx-md-4">
                          <div className="text-center">  
                          </div>
                          <form id="payment-form" onSubmit={handleSubmit}>
                            <h4 style={{ fontWeight: "bold" }}>
                              Amount to be charged: ${charge_amount}
                              <br />
                              <br />
                            </h4>
                            <PaymentElement id="payment-element" />
                            <br />
                            <button
                              disabled={isLoading || !stripe || !elements}
                              id="submit"
                            >
                              <span class="btn btn-primary" id="button-text">
                                {isLoading ? (
                                  <div className="spinner" id="spinner"></div>
                                ) : (
                                  "Pay now"
                                )}
                              </span>
                            </button>
                            {/* Show any error or success messages */}
                            {message && (
                              <div id="payment-message">{message}</div>
                            )}
                          </form>
                        </div>
          

  );
}

